import { IRequestByPartnerIdAndProgramType } from 'legacy/lut/classes/models/service'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { fetchEPData } from 'partner360/services/masterDealer'

import { GET_EXTENDED_PARTNER_DATA_BY_ID } from '../configs'
import { selectExtendedPartnerData } from '../selectors'

export const getExtendedPartnerDataById = createAsyncThunk(
  GET_EXTENDED_PARTNER_DATA_BY_ID,
  async ({ partnerId, programType, options }: IRequestByPartnerIdAndProgramType) =>
    fetchEPData({ partnerId, programType }, options),
  {
    condition({ partnerId }, { getState }) {
      if (!partnerId) {
        return false
      }

      const state = getState()
      const extendedPartnerData = selectExtendedPartnerData(state)
      if (extendedPartnerData.base.status === RequestStatus.PENDING) {
        return false
      }

      return true
    },
  }
)
